<template>
  <h3>loading...</h3>
</template>
<script>
import qs from "qs";
export default {
  name: "loadIndex",
  data() {
    return {
      code: "",
    };
  },
  mounted() {
    console.log("loginSuccess");
    this.code = this.$route.query.code;
    if (this.code) {
      this.getToken();
    } else this.$alert(data.message);
  },
  methods: {
    getToken() {
      this.axios
        .post("api/WxQrLogin/GetUserToken", qs.stringify({ code: this.code }))
        .then((res) => {
          let data = res.data;
          console.log(data);
          if (data.resultType == 0) {
            this.$message.success(data.message);
            var jwt = data.appendData.jwt;
            localStorage.setItem("loginToken", "Bearer " + jwt.token);
            localStorage.setItem("tokenExpires", jwt.expiresLong);
            localStorage.setItem("loginType", 3);

            var user = data.appendData.user;
            console.log(user);
            localStorage.setItem("userInfo", user);
            this.$store.commit("setUser", user);
            this.$store.commit("setV20", user.isV20);
            this.getSsoApp();
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
    getSsoApp() {
      this.axios
        .post("api/YYT3PC/Home/GetSsoApp2")
        .then((res) => {
          if (res.data.resultType == 0) {
            localStorage.setItem("SsoApp", JSON.stringify(res.data.appendData));
            // this.$parent.loginSuccess();
            this.$router.push("/home");
          }
        })
        .catch((err) => this.$alert(err));
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/login/WxLoginSuccess.vue